import Action from '../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
const ModalCreateException =({languaje,mode,user,devices,server,setRegisterIsValid,dataMantto,setData,loading,setLoading,setError,setEditActive,editActive,closCreateManttoModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
      const dataAgencies=useFetch('cassia/exception_agencies','','','GET',server)

    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
   
    const [ManttoData,setManttoData]=useState({
        ip:(editActive)?devices.data.hosts.find(obj => obj.hostid === dataMantto.hostid).ip:"",
        host_id:(editActive)?dataMantto.hostid:0,
        agency_id:(editActive)?dataMantto.exception_agency_id:((dataAgencies.data.length!=0 && dataAgencies.data.length!=undefined)?dataAgencies.data.data[0].exception_agency_id:''),
        description:(editActive)?dataMantto.description:"",
        created_at:(editActive)?dataMantto.created_at.slice(0,-6):""
    })
    const [hostName,setHostName]=useState("") 
    const [hostLocation,setHostLocation]=useState("") 
    const [hostActivate,setHostActivate]=useState(0)
    
    const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
   
    //     console.log(host)
        useEffect(()=>{
        //    console.log("cambio host")
           if(host.length>=1){
               setHostName(host[0].name)
               setManttoData((prevState)=>{
                   return {
                       ...prevState,
                       ['host_id']:host[0].hostid
                   }
                   
               })
           }else{
               setHostName("")
               setManttoData((prevState)=>{
                   return {
                       ...prevState,
                       ['host_id']:0
                   }
                   
               })
               // setManttoData((prevState)=>{
               //     return {
               //         ...prevState,
               //         ['device_name']:""
               //     }

               // })
           }
      },[host])
      
    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

      useEffect(()=>{
       
            if( (ManttoData.agency_id===0 || ManttoData.agency_id==="" || ManttoData.created_at==="") || IpValid===false   ){
                setDisabled(true)
            }else{
                setDisabled(false)
            }
      },[ManttoData])

      
      const Registrar=()=>{
       
        let method='POST'
        let url_add=''
        let data={
            "exception_agency_id": ManttoData.agency_id,
            "description": ManttoData.description,
            "hostid": ManttoData.host_id,
            "created_at": ManttoData.created_at
          }
        if(editActive){
            // method='PUT'
            url_add='/update'
            data={
                "exception_agency_id": ManttoData.agency_id,
                "description": ManttoData.description,
                "hostid": ManttoData.host_id,
                "created_at": ManttoData.created_at,
                "exception_id": dataMantto.exception_id,
                "updated_at": ManttoData.created_at
              }
        }
        
        
        
        setLoading(true)
          const fetchDataPost = async () => {
            
         try {
            // console.log(method,server.url+'/api/v1/cassia/exceptions'+url_add)
          
            // console.log(localStorage.getItem('access_token'))
              const response = await fetch(server.url+'/api/v1/cassia/exceptions'+url_add, {
                method: method,  
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                body: JSON.stringify(data),
              });
            //  console.log(response)
              if (response.ok) {
                
                const data1 = await response.json();
                setLoading(false)
                // Manejo de la respuesta
                setData(data1)
                // console.log(data1);
                closCreateManttoModal()
              setRegisterIsValid(true)
              
              const timer = setTimeout(() => {
                setRegisterIsValid(false)
                setEditActive(false)
                closCreateManttoModal()
              }, 3000);
            
              } else {
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
                setHostName("")
                setManttoData({ip:"",host_id:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
                
            setLoading(false)
              // Manejo de errores
              setError(error)
              closCreateManttoModal()
              setRegisterIsValid(true)
              
              const timer = setTimeout(() => {
                setRegisterIsValid(false)
                setEditActive(false)
                closCreateManttoModal()
              }, 3000);
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
    const closeModal=()=>{
        setEditActive(false)
                closCreateManttoModal()
    }
    useEffect(()=>{
        if(editActive){
            
            setIpValid(validateIp(ManttoData.ip))
        }
    },[])
    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
          // console.log(server.url+'/api/v1/cassia/ci/search_host/'+ip)
          const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
              method: 'GET',  
              headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
              },
            });
          //   console.log(response)
            if (response.ok) {
              
              const data1 = await response.json();
              setLoadingM(false)
              // console.log(data1)
              if(data1.data.length==0){
                  sethost([])
              setHostName("")
              setHostLocation("")
              setHostActivate(0)
                  setMsgError(capitalizeFirstLetter(lang[languaje]['msgIpNoExiste']))
                  setIpValid(false)
              }else{
                  setIpValid(true)

              }
              sethost(data1.data)
              setDisabled(true)
            } else {
                const data1 = await response.json();
                throw new Error('Error en la solicitud');
            }
          } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['agency_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }
    
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError(capitalizeFirstLetter(lang[languaje]['ipNoValida']))
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
      };
      const [resultList,setResultList]=useState([])
      const handleSearchHost=(e)=>{
        
        const term = e.target.value;
        const {name,value}=e.target
        if(name=="ip"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['ip']:value
                }
                
            })
        }
        // console.log(value)
        // setInputIP(value)
        setIpValid(validateIp(value))
        
        const filteredResults = devices.data.hosts.filter((item) => {
            
            return Object.entries(item).some(([key, value]) => {
              if (key === 'ip' || key=== 'Host') {
                return String(value).toLowerCase().includes(term.toLowerCase());
              }
              return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
            });
          });
       
          setResultList(filteredResults)
      }
      
    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const {ip,host_id,agency_id,description,created_at}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                    {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+"  "+lang[languaje]['exception'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (listSearchIP)?<div className='closeListSearch' onClick={closeListSearch}>X</div>:''
                                        }
                                    
                                    <input required name="ip"  placeholder='Buscar por IP/Host' type="text" value={ip}
                                    onChange={handleSearchHost} onFocus={()=>{setListSearchIP(true)}} onBlur={()=>{setListSearchIP(true)}} />
                                    <div className={`container-searchHostMantto-list ${!true ? 'large' : 'small'}`}>
                
                   
                    {(listSearchIP)?
                    
                    <div className={`compact-searchHostMantto-list ${!true ? 'large' : 'small'}`}>
                    {
                        (2==="" )?'':(resultList.length==0)?<div className='row-searchHostMantto-list' >
                        {capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                    </div>:
                        
                        resultList.map((element, index) => (
                            <div className='row-searchHostMantto-list' id={index} onClick={()=>handleSelected(element)}>
                                <div className='cont-row-searchHostMantto-txt'>
                                    <div className='ip-row-searchHostMantto' >{element.ip+" / "}</div>
                                    <div> &nbsp; {element.Host}</div>
                                    {(element.latitude.replace(",", ".")<-90 || element.latitude.replace(",", ".")>90)?
                                    <div style={{color:'red'}}> &nbsp; {capitalizeFirstLetter(lang[languaje]['coordenadasErroneas'])}</div>:''
                                    }
                                    
                                </div>
                                {/* {(flagSearch)?element.ip:element.Host} */}
                            </div>
                        ))
                       
                            
                    }
                    
                     
                </div>:''}
                
               
            </div>
                                        <label className='label-GS active'>Host IP</label>
                                        {
                                            // IpValid?'':<span className='form-msg-error-gs'> {msgError}</span>
                                        }
                                        
                                    </div>
                                    
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                    <input required name="host_id" style={{background: "#ddd"}} placeholder='Realize una busqueda de dispositivo' type="text" value={hostName}
                                    onChange={handleChange} disabled />
                                        <label className='label-GS active '>Host name</label>
                                        
                                    </div>
                                   
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                        {
                                            (dataAgencies.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar agencia...'} opGeneral={false} txtOpGen={''}  opt_de={agency_id} origen={'Admin'} data={dataAgencies.data.data} loading={dataAgencies.loading}  titulo='Agencia' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['agencia'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange} />
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                    <input required name="created_at"  type="datetime-local" value={created_at}
                                    onChange={handleChange} />
                                        <label className='label-GS active'>{capitalizeFirstLetter(lang[languaje]['fechaInicio'])}</label>
                                       
                                        
                                    </div>
                                
                                    
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closeModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateException